<ng-container *transloco="let t; prefix: 'scDeviceAuth'">
	<prism-dialog [visible]="true" data-testid="single-device-password-setup-dialog">
		<span slot="dialog-title" class="sh-password-header" data-testid="dialog-title">
			{{ data.title }}
		</span>
		<sh-device-password-configuration
			[options]="{ keepExisting: false }"
			(passwordChanged)="passwordChanged($event)"
		></sh-device-password-configuration>
		<div slot="dialog-footer-buttons" class="sh-stretch-buttons">
			<prism-button
				id="sh-set-password-button"
				variant="bright"
				class="sh-password-button"
				[disabled]="!newPassword"
				(click)="onSubmit()"
				>{{ t('common.buttons.set-password') }}
			</prism-button>
			<prism-button id="sh-use-without-password-button" variant="text" (click)="onCancel()"
				>{{ t('common.buttons.use-without-password') }}
			</prism-button>
		</div>
	</prism-dialog>
</ng-container>
